import { useParams } from 'react-router-dom';
import { GuestSessionBoundary } from './GuestSessionBoundary';
import { GuestShell } from './GuestShell';
import { QuoteDetailPage } from '../quotes/QuoteDetailPage';

/** The quote a guest link points at, in the nav-less guest shell. */
export function GuestQuotePage() {
	const { id } = useParams<{ id: string }>();

	return (
		<GuestSessionBoundary>
			<GuestShell>
				<QuoteDetailPage guest key={id} />
			</GuestShell>
		</GuestSessionBoundary>
	);
}
